"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformComponent = void 0;
const TransformObject_1 = require("./TransformObject");
const TransformComponentSymbol_1 = require("./TransformComponentSymbol");
const TransformComponentFootprint_1 = require("./TransformComponentFootprint");
class TransformComponent extends TransformObject_1.TransformObject {
    constructor(parent, args) {
        super(parent, {
            ...args,
            symbolObjects: new Map(),
            footprintObjects: new Map(),
        }, args.baseComponent.name, new Set([TransformComponentSymbol_1.TransformComponentSymbol, TransformComponentFootprint_1.TransformComponentFootprint]));
    }
    get dependencies() {
        return [...this._sharedData.symbolObjects.values(), ...this._sharedData.footprintObjects.values()];
    }
    add(child) {
        this.assertCanAdd(child);
        if (child instanceof TransformComponentSymbol_1.TransformComponentSymbol) {
            this._sharedData.symbolObjects.set(child.deduplicationKey, child);
        }
        else if (child instanceof TransformComponentFootprint_1.TransformComponentFootprint) {
            this._sharedData.footprintObjects.set(child.deduplicationKey, child);
        }
    }
    linkTo(primary) {
        for (const symbol of this._sharedData.symbolObjects) {
            primary._sharedData.symbolObjects.set(symbol[0], symbol[1]);
        }
        for (const footprint of this._sharedData.footprintObjects) {
            primary._sharedData.footprintObjects.set(footprint[0], footprint[1]);
        }
        super.linkTo(primary);
    }
    compile() {
        const component = this.getBaseComponent();
        const seenSymbolRefs = new Set();
        for (const symbol of this._sharedData.symbolObjects.values()) {
            const compiled = symbol.compiled;
            if (seenSymbolRefs.has(compiled.result.ref)) {
                continue;
            }
            seenSymbolRefs.add(compiled.result.ref);
            component.symbols.push(compiled.result);
            for (const [pin, signalTemplate] of compiled.pinSignals) {
                const existingSignal = component.signals.find((s) => s.id === signalTemplate.id);
                if (existingSignal) {
                    existingSignal.pinRefs.push(pin.ref);
                }
                else {
                    component.signals.push({
                        padRefs: [],
                        name: signalTemplate.id.toString(),
                        ...signalTemplate,
                        pinRefs: [pin.ref],
                    });
                }
            }
        }
        component.numPins = new Set(component.symbols.flatMap((s) => s.pins.map((p) => p.ref))).size;
        for (const footprint of this._sharedData.footprintObjects.values()) {
            component.footprints.push(footprint.compiled.result);
            for (const [pad, signalTemplate] of footprint.compiled.padSignals) {
                const existingSignal = component.signals.find((s) => s.id === signalTemplate.id);
                if (existingSignal) {
                    existingSignal.padRefs.push(pad.ref);
                }
                else {
                    component.signals.push({
                        pinRefs: [],
                        name: signalTemplate.id.toString(),
                        ...signalTemplate,
                        padRefs: [pad.ref],
                    });
                }
            }
        }
        component.numPads = new Set(component.footprints.flatMap((s) => s.pads.flatMap((p) => p.ref))).size;
        return component;
    }
    getBaseComponent() {
        return {
            numPins: 0,
            numPads: 0,
            symbols: [],
            footprints: [],
            signals: [],
            ...(this._sharedData.baseComponent ?? {}),
        };
    }
}
exports.TransformComponent = TransformComponent;
//# sourceMappingURL=TransformComponent.js.map